import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=a93aed18&scoped=true"
import script from "./main-header.vue?vue&type=script&lang=ts"
export * from "./main-header.vue?vue&type=script&lang=ts"
import style0 from "./main-header.vue?vue&type=style&index=0&id=a93aed18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93aed18",
  null
  
)

export default component.exports